import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { BiometricService } from 'src/app/contexts/biometric/infraestructure/services/biometric.service';
import { MessageError } from 'src/app/contexts/login/infrastructure/core/components/error/message-error';
import { B2cService } from '../../../infraestructure/services/b2c.service';

import { ErrorMessageFactory } from 'src/app/contexts/login/infrastructure/core/components/error/error-message-factory';

@Component({
  selector: 'app-reception-login',
  templateUrl: './reception-login.component.html',
  styleUrls: ['./reception-login.component.scss']
})
export class ReceptionLoginComponent implements AfterViewInit {

  @ViewChild('loaderIndicator') loaderIndicator!: ElementRef<any> | undefined;

  isLoading: boolean = true;
  isValidation: boolean = false;
  isErrorAuthentication: boolean = false;
  messageLoading: string = 'Espere un momento por favor';
  isMessageError: boolean = false;

  private readonly errorMessageFactory = new ErrorMessageFactory();
  messageError: MessageError = this.errorMessageFactory.errorConnection();

  constructor(private biometricService: BiometricService,
    private b2cService: B2cService,
    private cdr: ChangeDetectorRef) {

  }

  async ngAfterViewInit() {
    this.openLoaderIndicator();
    try {

      this.isErrorAuthentication = this.biometricService.errorAuthentication();

      if (this.isErrorAuthentication) {
        this.invalidateError();
        return;
      }

      const { status, code } = await this.b2cService.validation();

      if (status) {
        const getUrl = this.b2cService.getUrlRedirect(code);
        const safe = this.b2cService.isAllowedRedirectUrl(getUrl);
        if (safe) {
          window.location.assign(getUrl);
        }
        else {
          this.invalidateError();
        }
      }
      else {

        this.invalidateError();
        if (code == 409) {
          this.messageError = this.errorMessageFactory.linkError();
        }

      }
    } catch (error: any) {

      this.invalidateError();
      if (error?.status == 409) {
        this.messageError = this.errorMessageFactory.linkError();
      }

    }
    this.cdr.detectChanges();

  }

  invalidateError() {
    this.isMessageError = true;
    this.biometricService.invalide();
    this.closeLoaderIndicator();
  }

  openLoaderIndicator() {
    this.loaderIndicator?.nativeElement.open();
  }

  closeLoaderIndicator() {
    this.isLoading = false;
    this.loaderIndicator?.nativeElement.close();
  }

  redirectSend(redirectTo: string | null) {
    if (redirectTo) {
      window.open(redirectTo, '_blank', 'noopener');
    }
  }
}
